<div class="otp-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content>
    <p>{{ data.subtitle }}</p>
    <p>Email: {{ maskedEmail }}</p>

    @if (!otpSent) {
    <div class="send-otp-section">
      <button mat-raised-button color="primary" (click)="sendOtp()" [disabled]="isSending">
        {{ getSendButtonText() }}
      </button>
    </div>
    } @if (otpSent) {
    <div class="otp-section">
      <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="full-width">
          <mat-label>Enter OTP</mat-label>
          <input
            matInput
            formControlName="otp"
            maxlength="6"
            (input)="onOtpInput($event)"
            placeholder="6-digit code"
          />
          @if (otpForm.get('otp')?.hasError('required')) {
          <mat-error> OTP is required </mat-error>
          } @if (otpForm.get('otp')?.hasError('pattern')) {
          <mat-error> OTP must be 6 digits </mat-error>
          }
        </mat-form-field>
        @if (errorMessage) {
        <div class="error-message">
          {{ errorMessage }}
        </div>
        }
        <div class="resend-section">
          <button
            type="button"
            mat-button
            (click)="resendOtp()"
            [disabled]="resendDisabled || isResending"
          >
            {{ getResendButtonText() }}
          </button>
        </div>
      </form>
    </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    @if (otpSent) {
    <button
      mat-raised-button
      color="primary"
      (click)="verifyOtp()"
      [disabled]="isVerifying || otpForm.invalid"
    >
      {{ isVerifying ? 'Verifying...' : 'Verify' }}
    </button>
    }
  </mat-dialog-actions>
</div>
